import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import getBanner from '../../../v2/selectors/getBanner';
import {getSiteId} from '../../../v2/selectors/selectors';
import useStyles from './Background.styles';

export function Background(props) {
  const classes = useStyles(props);
  
  if (!props.banner) return null;
  
  return (
    <div className={classes.background} data-test={`Background__${props.componentName}`} />
  );
}

const mapStateToProps = state => ({
  banner: getBanner(state),
  siteId: getSiteId(state) === 95 || getSiteId(state) === 83 || getSiteId(state) === 208,
});

Background.propTypes = {
  componentName: PropTypes.string,
  banner: PropTypes.string,
  siteId: PropTypes.bool,
};

export default connect(mapStateToProps)(Background);
